import React, { useEffect } from 'react'
import { Router, Route, Switch, HashRouter } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { history } from '../helpers/history';
import AuthLayout from '../layout/layout';
import { getIp, titlePage } from '../layout/redux/layoutActions';
import { useDispatch, useSelector } from 'react-redux';

import paginaAlerta from './alertPage';
import errorPage from './errorPage';
import emDesenvolvimento from './emDesenvolvimento';
import login from '../modules/login/login';
import recupararSenha from '../modules/login/recupararSenha';


import projetosLoja from '../modules/publica/projetos/projetos';
import calculadoraAdquirir from '../modules/publica/calculadora/adquirirAtivos';


import basededados from '../modules/basededados/basededados';

import csatcliente from '../modules/empresa/csatcliente/csatcliente';
import npscliente from '../modules/empresa/npscliente/npscliente';
import rankingclientecsat from '../modules/empresa/rankingclientecsat/rankingclientecsat';
import rankingclientenps from '../modules/empresa/rankingclientenps/rankingclientenps';
import csatconcorrentes from '../modules/empresa/csatconcorrentes/csatconcorrentes';
import indicadoresEmpresas from '../modules/empresa/indicadores/indicadores';
import analiseswotunificada from '../modules/empresa/swot/swot';

import infoGrupo from '../modules/grupos/infoGrupo/infoGrupo';
import rankingcsat from '../modules/grupos/rankingcsat/rankingcsat';
import rankingnps from '../modules/grupos/rankingnps/rankingnps';
import indicadores from '../modules/grupos/indicadores/indicadores';
import swot from '../modules/grupos/swot/swot';

import comentarios from '../modules/comentarios/comentarios';
import npsconcorrentes from '../modules/empresa/npsconcorrentes/npsconcorrentes';
import meusProjetos from '../modules/meusProjetos/meusProjetos';
import configurar from '../modules/meusProjetos/configurar/configurar';
import usuarios from '../modules/usuarios/usuarios';
import projetos from '../modules/projetos/projetos';
import cadastro from '../modules/login/cadastro';
import redescsatcliente from '../modules/redes/csatcliente/csatcliente';
import redesnpscliente from '../modules/redes/npscliente/npscliente';
import redescsatconcorrentes from '../modules/redes/csatconcorrentes/csatconcorrentesredes';
import redesnpsconcorrentes from '../modules/redes/npsconcorrentes/npsconcorrentesredes';
import indicadoresredes from '../modules/redes/indicadores/indicadores';

//import configurarempresas from '../modules/meusProjetos/configurar/empresas/empresas';


//PRODUTOS COMENTARIOS
import produtoscsatcliente from '../modules/produtos/csatcliente/csatcliente';
import produtosnpscliente from '../modules/produtos/npscliente/npscliente';
import produtoscsatconcorrentes from '../modules/produtos/csatconcorrentes/csatconcorrentesprodutos';
import produtosnpsconcorrentes from '../modules/produtos/npsconcorrentes/npsconcorrentesprodutos';
import indicadoresprodutos from '../modules/produtos/indicadores/indicadores';
import swotprodutos from '../modules/produtos/swot/swot';
import infoGrupoProdutos from '../modules/produtos/infoGrupo/infoGrupo';
import comentariosnovos from '../modules/comentnovo/comentarios';
import plano7dias from '../modules/planos/plano7dias/plano7dias';
import plano30dias from '../modules/planos/plano30dias/plano30dias';

import minhasAssinaturas from '../modules/minhasAssinaturas/minhasAssinaturas';
import upgradeConta from '../modules/upgradeConta/upgradeConta';
import cadastroConvite from '../modules/login/cadastro-convite';
import questionario from '../modules/questionario/questionario';

import TrackerGTM from './trackergtm';

import dashpublic from '../modules/dashboard/dashboard';

import PdcaRouteEntry from '../modules/pdca/base/pdcaRouteEntry'
import Setup from '../modules/pdca/setup/setup'
import Priorities from '../modules/pdca/priorities/priorities'
import Plan from '../modules/pdca/plan/plan'
import Do from '../modules/pdca/do/do'
import Check from '../modules/pdca/check/check'
import Act from '../modules/pdca/act/act'
import History from '../modules/pdca/history/history'
import Blacklist from '../modules/pdca/blacklist/blacklist'
import Integrations from '../modules/pdca/integrations/integrations'
import IntegrationsTrelloCallback from '../modules/pdca/integrationsTrelloCallback/integrationsTrelloCallback'
import IntegrationsClickupCallback from '../modules/pdca/integrationsClickupCallback/integrationsClickupCallback'
import StrategicContext from '../modules/pdca/strategiccontext/strategiccontext'

import competitorgap from '../modules/competitorgap/competitorgap'
import benchmark from '../modules/benchmark/benchmark';

//Impedir acesso ao dashboard público no domínio principal
// Componente para redirecionar dashboards do domínio principal para o subdomínio público
const DashboardRedirect = ({ match }) => {
  const { id } = match.params;
  const publicDomain = process.env.REACT_APP_PUBLIC_DASHBOARD_DOMAIN;
  
  // Se a variável de ambiente não estiver configurada, renderiza o dashboard normal (comportamento antigo)
  if (!publicDomain) {
    const DashComponent = dashpublic;
    return <DashComponent />;
  }
  
  // Redireciona para o subdomínio público mantendo o ID
  window.location.replace(`${publicDomain}/d/${id}`);
  return null;
};


const PrivateRoute = ({ component: Component, path, sidebar=false }) => {
  const dispatch = useDispatch()
  const pathname =  window.location.pathname
  
  const scrollToTop = () => {
    const content = document.getElementById('box-container')
    content?.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  useEffect(()=> {
    dispatch(titlePage({pathname}))
    // dispatch(titlePage({pathname, menuItens: menuItens()}))
    scrollToTop()
  },[pathname])

  return (
    <Route
      exact
      path={path}
      render={props =>
        <AuthLayout sidebar={sidebar}>
          <Component {...props} />
        </AuthLayout>
      }
    />
  )
}

export default () => {

  return (
    <Router history={history}>
      
      {/* <TrackerGTM />  DESCOMENTAR NA HORA DE USAR O GTM*/}
      <TrackerGTM />
      
      <Switch>

        
        <Route path='/' exact component={login} />

        <Route path='/login' exact component={login} />

        <Route path='/cadastro' exact component={cadastro} />
        <Route path='/signup' exact component={cadastro} />

        <Route path='/cadastroConvite' exact component={cadastroConvite} />
        <Route path='/signup-invite' exact component={cadastroConvite} />

        <Route path='/recuperarsenha' exact component={recupararSenha} />
        <Route path='/recoverpassword' exact component={recupararSenha} />

        <Route path='/recuperarsenha/:tolkenRecuperar' exact component={recupararSenha} />
        <Route path='/recoverpassword/:tolkenRecuperar' exact component={recupararSenha} />

        
        <Route path='/ResetPassword' exact component={recupararSenha} />
        <Route path='/ResetPassword/:tolkenRecuperar' exact component={recupararSenha} />
        
        <Route path='/questionario' exact component={questionario} />
        <Route path='/questionnaire' exact component={questionario} />


        <Route path='/lojaprojetos' exact component={projetosLoja} />
        <Route path='/projectstore' exact component={projetosLoja} />

        <Route path='/calculadoraAdquirir' exact component={calculadoraAdquirir} />
        <Route path='/acquirecalculator' exact component={calculadoraAdquirir} />
        
        {/* Dashboard público - redireciona para subdomínio se não estiver nele */}
<Route 
  path='/d/:id' 
  exact 
  component={window.location.hostname.includes('dash.') ? dashpublic : DashboardRedirect} 
/>


        <PrivateRoute path='/checkoutsucesso' exact component={paginaAlerta} />
        <PrivateRoute path='/checkoutsuccess' exact component={paginaAlerta} />

        <PrivateRoute path='/meusprojetos' exact component={meusProjetos} />
        <PrivateRoute path='/myprojects' exact component={meusProjetos} />

        <PrivateRoute path='/meusprojetos/:idProjetos' exact component={meusProjetos} />
        <PrivateRoute path='/myprojects/:idProjetos' exact component={meusProjetos} />

        <PrivateRoute path='/meusprojetos/:idProjetos/configurar' exact component={configurar} />
        <PrivateRoute path='/myprojects/:idProjetos/configure' exact component={configurar} />
        
        

        <PrivateRoute path='/meusprojetos/:idProjetos/configurar/:idPasso' exact component={configurar} />
        <PrivateRoute path='/myprojects/:idProjetos/configure/:idPasso' exact component={configurar} />
        

        <PrivateRoute path='/minhasassinaruras' exact component={minhasAssinaturas} />
        <PrivateRoute path='/mysubscriptions' exact component={minhasAssinaturas} />

        <PrivateRoute path='/upgradeconta' exact component={upgradeConta} />
        <PrivateRoute path='/accountupgrade' exact component={upgradeConta} />

        <PrivateRoute path='/usuarios' exact component={usuarios} />
        <PrivateRoute path='/users' exact component={usuarios} />

        <PrivateRoute path='/projetos' exact component={projetos} />
        <PrivateRoute path='/projects' exact component={projetos} />

        <PrivateRoute path='/meusprojetos/:idProjetos/resumoprojeto' exact component={basededados} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/projectsummary' exact component={basededados} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/csat' exact component={csatcliente} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/csat' exact component={csatcliente} sidebar={true} />



        <PrivateRoute path='/meusprojetos/:idProjetos/nps' exact component={npscliente} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/nps' exact component={npscliente} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/csatestabelecimentos' exact component={rankingclientecsat} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/csatstores' exact component={rankingclientecsat} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/npsestabelecimentos' exact component={rankingclientenps} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/npsstores' exact component={rankingclientenps} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/csatconcorrentes' exact component={csatconcorrentes} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/csatcompetitors' exact component={csatconcorrentes} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/npstconcorrentes' exact component={npsconcorrentes} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/npscompetitors' exact component={npsconcorrentes} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/csatredescsatcliente' exact component={redescsatcliente} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/csatsocialclient' exact component={redescsatcliente} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/npsredescsatcliente' exact component={redesnpscliente} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/npssocialclient' exact component={redesnpscliente} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/csatredesconcorrentes' exact component={redescsatconcorrentes} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/csatsocialcompetitors' exact component={redescsatconcorrentes} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/npsredesconcorrentes' exact component={redesnpsconcorrentes} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/npssocialcompetitors' exact component={redesnpsconcorrentes} sidebar={true} />
        
        
        
        <PrivateRoute path='/meusprojetos/:idProjetos/indicadoresempresas' exact component={indicadoresEmpresas} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/companyindicators' exact component={indicadoresEmpresas} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/analiseswotunificada' exact component={analiseswotunificada} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/swotanalysis' exact component={analiseswotunificada} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/analiseswotunificada/:IdSwot' exact component={analiseswotunificada} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/swotanalysis/:IdSwot' exact component={analiseswotunificada} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/indicadoresredes' exact component={indicadoresredes} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/socialindicators' exact component={indicadoresredes} sidebar={true} />

        {/* PRODUTOS */}
        <PrivateRoute path='/meusprojetos/:idProjetos/csatprodutoscsatcliente' exact component={produtoscsatcliente} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/csatproductclient' exact component={produtoscsatcliente} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/npsprodutosnpscliente' exact component={produtosnpscliente} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/npsproductclient' exact component={produtosnpscliente} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/csatprodutosconcorrentes' exact component={produtoscsatconcorrentes} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/csatproductcompetitor' exact component={produtoscsatconcorrentes} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/npsprodutosconcorrentes' exact component={produtosnpsconcorrentes} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/npsproductcompetitor' exact component={produtosnpsconcorrentes} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/indicadoresprodutos' exact component={indicadoresprodutos} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/productindicators' exact component={indicadoresprodutos} sidebar={true} />

       
        <PrivateRoute path='/meusprojetos/:idProjetos/resumogruposprodutos' exact component={infoGrupoProdutos} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/productgroupsummary' exact component={infoGrupoProdutos} sidebar={true} />

        {/* Não usamos mais swot de produtos, mas deixamos aqui somente porque ainda temos no código em src\modules\produtos\swot\swotContent.js */}
        <PrivateRoute path='/meusprojetos/:idProjetos/analiseswotprodutos' exact component={swotprodutos} sidebar={true} />
        <PrivateRoute path='/meusprojetos/:idProjetos/analiseswotprodutos/:IdSwot' exact component={swotprodutos} sidebar={true} />

        {/* COMENTÁRIOS */}
        <PrivateRoute path='/meusprojetos/:idProjetos/comentariosnovos' exact component={comentariosnovos} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/feedbacks' exact component={comentariosnovos} sidebar={true} />

        {/* PLANOS: REMOVIDO DEPOIS QUE INSERIMOS PDCA
        <PrivateRoute path='/meusprojetos/:idProjetos/pl7' exact component={plano7dias} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/pl7' exact component={plano7dias} sidebar={true} />
        
        <PrivateRoute path='/meusprojetos/:idProjetos/pl30' exact component={plano30dias} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/pl30' exact component={plano30dias} sidebar={true} />
        */}


        <PrivateRoute path='/meusprojetos/:idProjetos/resumogrupos' exact component={infoGrupo} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/storegroupsummary' exact component={infoGrupo} sidebar={true} />
           
        <PrivateRoute path='/meusprojetos/:idProjetos/csatestabelecimentosconcorrentes' exact component={rankingcsat} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/csatstorescompetitors' exact component={rankingcsat} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/npsestabelecimentosconcorrentes' exact component={rankingnps} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/npsstorescompetitors' exact component={rankingnps} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/indicadores' exact component={indicadores} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/storeindicators' exact component={indicadores} sidebar={true} />

        <PrivateRoute path='/meusprojetos/:idProjetos/analiseswot/:IdSwot' exact component={swot} sidebar={true} />
        <PrivateRoute path='/myprojects/:idProjetos/swot/:IdSwot' exact component={swot} sidebar={true} />

        
        <PrivateRoute path='/myprojects/:idProjetos/pdca' exact component={PdcaRouteEntry} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/setup' exact component={Setup} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/priorities' exact component={Priorities} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/plan' exact component={Plan} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/do' exact component={Do} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/check' exact component={Check} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/act' exact component={Act} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/history' exact component={History} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/blacklist' exact component={Blacklist} />
        <PrivateRoute path='/myprojects/:idProjetos/pdca/integrations' exact component={Integrations} />
        <PrivateRoute
          path='/myprojects/:idProjetos/pdca/integration/trello-callback'
          exact
          component={IntegrationsTrelloCallback}
        />
        <PrivateRoute
          path='/myprojects/:idProjetos/pdca/integration/clickup-callback'
          exact
          component={IntegrationsClickupCallback}
        />

        <PrivateRoute path='/myprojects/:idProjetos/pdca/strategic-context' exact component={StrategicContext} />

        <PrivateRoute path='/myprojects/:idProjetos/competitorgaps' exact component={competitorgap} />

        <PrivateRoute path='/myprojects/:idProjetos/benchmark' exact component={benchmark} sidebar={true} />

        <Route component={errorPage} />
      </Switch>
    </Router>
  )
}